import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ShoppingState {
    cartArray: any[];
    cartQuantity: number;
    listArray: any[];
    currentPrebasketProduct: Record<string, any>;
    prebasketUpdated: boolean;
}

interface ShoppingContextType extends ShoppingState {
    setCartArray: (_cartArray: any[]) => void;
    setListArray: (_listArray: any[]) => void;
    setCurrentPrebasketProduct: (_product: Record<string, any>) => void;
    setPreBasketUpdated: (_updated: boolean) => void;
}

const initialState: ShoppingState = {
    cartArray: [],
    cartQuantity: 0,
    listArray: [],
    currentPrebasketProduct: {},
    prebasketUpdated: false,
};

const ShoppingContext = createContext<ShoppingContextType | undefined>(undefined);

export const ShoppingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [state, setState] = useState<ShoppingState>(initialState);

    const setCartArray = (cartArray: any[]) => setState((s) => ({ ...s, cartArray }));
    const setListArray = (listArray: any[]) => setState((s) => ({ ...s, listArray }));
    const setCurrentPrebasketProduct = (currentPrebasketProduct: Record<string, any>) =>
        setState((s) => ({ ...s, currentPrebasketProduct }));
    const setPreBasketUpdated = (prebasketUpdated: boolean) => setState((s) => ({ ...s, prebasketUpdated }));

    const value: ShoppingContextType = {
        ...state,
        setCartArray,
        setListArray,
        setCurrentPrebasketProduct,
        setPreBasketUpdated,
    };

    return <ShoppingContext.Provider value={value}>{children}</ShoppingContext.Provider>;
};

export const useShopping = (): ShoppingContextType => {
    const context = useContext(ShoppingContext);
    if (!context) {
        throw new Error('useShopping must be used within a ShoppingProvider');
    }
    return context;
};
